export type IconType = keyof typeof iconsSrcMap

export const iconsSrcMap = {
  award: { name: "Award.svg" },
  car: { name: "Car.svg" },
  box: { name: "Box.svg" },
  pricetag: { name: "Pricetag.svg" },
  return: { name: "Return.svg" }
}
